export default __webpack_public_path__ + "static/media/Dubai_loop.c239f51d.webm";